const root = '/database-proxy';
const baseRoute = (path = '') => `${root}${path}`;

export default {
  root,
  /** Create a new configuration. */
  create: baseRoute('/create'),
  /** Continue a configuration that has not yet been generated. */
  resume: baseRoute('/resume'),
  /** Update a configuration that has already been generated. */
  update: baseRoute('/update'),
} as const;
